import loadable from '@loadable/component';

// 懒加载组件
const DrugOrderManagement = loadable(() => import('./drugOrderManagement/DrugOrderManagement'));
const WhereManage = loadable(() => import('./drugOrderManagement/whereManage/WhereManage'));
const DrugDeliveryManagement = loadable(() => import('./drugDeliveryManagement/DrugDeliveryManagement'));
const DrugDeliveryManagementDetail = loadable(() => import('./drugDeliveryManagement/drugDeliveryManagementDetail/DrugDeliveryManagementDetail'));
const DrugReturnManagement = loadable(() => import('./drugReturnManagement/DrugReturnManagement'));
const AgreeDetail = loadable(() => import('./drugReturnManagement/AgreeDetail/AgreeDetail'));

export const subRoutes = [
  {
    path: '/DrugOrderManagement',
    component: DrugOrderManagement
  },
  {
    path: '/WhereManage',
    component: WhereManage
  },
  {
    path: '/DrugDeliveryManagement',
    component: DrugDeliveryManagement
  },
  {
    path: '/DrugDeliveryManagementDetail',
    component: DrugDeliveryManagementDetail
  },
  {
    path: '/DrugReturnManagement',
    component: DrugReturnManagement
  },
  {
    path: '/AgreeDetail',
    component: AgreeDetail
  }
];
